import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileTabBar from "./MobileTabBar";
import FloatingActions from "./FloatingActions";
import ScrollToTop from "./ScrollToTop";
import { usePageviewTracker } from "@/lib/hooks";

export default function PublicLayout() {
  usePageviewTracker();
  return (
    <div className="min-h-screen flex flex-col bg-white text-txt-900">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <MobileTabBar />
      <FloatingActions />
    </div>
  );
}
